var _rect, _text, _text2, _path, _line, _line2, _line3, _rect2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _rect3, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _rect4, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _rect5, _text25, _text26, _text27, _text28, _text29, _text30, _rect6, _text31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase1Fig3DoctrineLadder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1244 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1244,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Four doctrine rungs, learned in production order")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Each rung names the doctrine above the specimen defect that produced it.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 552 L332 552 L332 502 L628 502 L628 452 L924 452 L924 402 L1196 402",
    fill: "none",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 342,
    x2: 340,
    y2: 298,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 608,
    y1: 292,
    x2: 636,
    y2: 248,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 904,
    y1: 242,
    x2: 932,
    y2: 198,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 330,
    width: 260,
    height: 210,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 358,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "RUNG 1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 384,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The gate is a floor")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 428,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "SPECIMEN")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 450,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "a $1,340 CAC plus missing")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 468,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "fields plus a mojibake")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 486,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "character, all through")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 504,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "a passing gate")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 280,
    width: 260,
    height: 210,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 308,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "RUNG 2")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 334,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The audit above the gate")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 378,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "SPECIMEN")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 400,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "the omitted 0.9235")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 418,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "net-earnings adjustment,")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 436,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "running about 8.3")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 454,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "percent high")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 230,
    width: 260,
    height: 210,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 258,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "RUNG 3")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 284,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The test can encode")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 304,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "the bug")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 332,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "SPECIMEN")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 354,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "0.1 plus 0.2 arriving as")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 372,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#DC2626"
  }, "0.30000000000000004")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 390,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "and rejecting a correct")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 408,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "submission")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 180,
    width: 260,
    height: 210,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 208,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "RUNG 4")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 234,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Fabrication by coercion")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 278,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "SPECIMEN")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 300,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#DC2626"
  }, "float(x or 1)")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 318,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "turning an explicit 0")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 954,
    y: 336,
    fontSize: 12.5,
    fill: "#DC2626"
  }, "into a market size")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 576,
    width: 1148,
    height: 42,
    rx: 10,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 602,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Every specimen was found behind a ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#16A34A",
    fontWeight: 600
  }, "green"), " gate.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase1Fig3DoctrineLadder);
export default __webpack_public_path__ + "static/media/case1-fig3-doctrine-ladder.54d2eaa80c1b0b02e70fed5d56ffdd9d.svg";
export { ForwardRef as ReactComponent };